import { gql } from "@apollo/client";
export const typeDef = gql`
  type Ranking {
    id: String
    rank: Int
    meta: MediaMeta
  }

  type Query {
    ranking(target: String, range: String, channel: Int, count: Int): [Ranking]
  }
`;
export const resolvers = {
  Query: {
    ranking: async (_parent, _ref, _ref2) => {
      let {
        target,
        range,
        channel,
        count
      } = _ref;
      let {
        dataSources
      } = _ref2;
      const res = await dataSources.meta.rankingSearch(channel, target, range, count);
      const ranking = res.metas.map((meta, i) => {
        const rank = i + 1;
        return {
          id: `${rank}-${meta.id}`,
          rank,
          meta
        };
      });
      return ranking;
    }
  }
};